module.exports = __webpack_public_path__ + "static/media/motomelbicicletas.ab9d7df2.png";